import { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../../utils/config";

const CustomerSearchSelect = ({
  value,
  onChange,
  token,
  placeholder = "Search customer by name / phone / GSTIN",
}) => {
  const [q, setQ] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!q || q.trim().length < 2) {
      setOptions([]);
      return;
    }

    const t = setTimeout(async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${API_BASE_URL}/api/customers`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { q, limit: 10 },
        });

        const payload = res.data;
        const rows = Array.isArray(payload?.rows)
          ? payload.rows
          : Array.isArray(payload)
          ? payload
          : [];

        setOptions(rows);
      } catch (err) {
        console.error("Customer search error", err);
        setOptions([]);
      } finally {
        setLoading(false);
      }
    }, 300);

    return () => clearTimeout(t);
  }, [q, token]);

  return (
    <div>
      {/* Search box */}
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder={placeholder}
        className="border p-2 rounded w-full mb-2"
      />

      {/* Select */}
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="border p-2 rounded w-full"
      >
        <option value="">Select Customer</option>
        {options.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name}
            {c.type ? ` (${c.type})` : ""}
          </option>
        ))}
      </select>

      {loading && (
        <div className="text-xs text-slate-500 mt-1">Searching…</div>
      )}
    </div>
  );
};

export default CustomerSearchSelect;
